export const autoHide = true;
export const timeout = '5000';
